/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
  LabelProps,
  Label,

} from 'recharts';
import { chartsConfig } from './config';
import { themeColors } from '../../Charts/common';

interface BaseScatterChartProps<T> {
  xAxisDataKey: keyof T;
  yAxisDataKey: keyof T;
  yAxisDomain?: [number | string, number | string];
  xAxisDomain?: [number | string, number | string];
  yAxisLabel?: string;
  xAxisLabel?: string;
  data: T[];
  height?: number;
  width?: number;
  margin?: {
    top: number;
    right: number;
    left: number;
    bottom: number;
  };
}

const renderCustomizedLabel = (props: LabelProps) => {
  const {
    x, y, value,
  } = props;
  return (
    <text
      x={x != null ? +x + 14 : 0}
      y={y != null ? +y + 5 : 0}
      fontSize={13}
      alignmentBaseline="middle"
      fill="#222"
    >
      {value}
    </text>
  );
};

export function BaseScatterChart<T>(
  props: BaseScatterChartProps<T>) {
  const {
    xAxisDataKey,
    yAxisDataKey,
    yAxisDomain,
    xAxisDomain,
    yAxisLabel,
    xAxisLabel,
    data,
    height,
    width,
    margin = {
      top: 0, right: 10, left: -20, bottom: 10,
    },
  } = props;

  return (
    <ScatterChart
      width={width}
      height={height}
      margin={margin}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis
        dataKey={String(xAxisDataKey)}
        unit="%"
        domain={xAxisDomain ?? [0, 'dataMax + 10']}
        type="number"
        name={String(xAxisDataKey)}
        tick={{ fontSize: chartsConfig.tick.fontSize, color: chartsConfig.areaChart.tick.color }}
        dy={chartsConfig.xLabel.padding}
      >
        {xAxisLabel && (
          <Label value={xAxisLabel} fontSize={12} offset={-10} position="insideBottom" />
        )}

      </XAxis>
      <YAxis
        dataKey={String(yAxisDataKey)}
        type="number"
        domain={yAxisDomain ?? [0, 'dataMax + 10']}
        tickCount={10}
        unit="%"
        name={String(yAxisDataKey)}
        tick={{ fontSize: chartsConfig.tick.fontSize }}
        dx={chartsConfig.yLabel.padding}
      >
        {yAxisLabel && (

          <Label
            value={yAxisLabel}
            style={{ textAnchor: 'middle' }}
            fontSize={12}
            offset={3}
            position="left"
            angle={270}
          />
        )}

      </YAxis>
      <Scatter name="name" data={data} isAnimationActive={false} fill={themeColors.secondary}>
        <LabelList dataKey="name" content={renderCustomizedLabel} />
      </Scatter>

    </ScatterChart>
  );
}
